import { useUserInfoStore } from '@/stores/user/userInfoStore'

import cn from './AttributeProcessing.module.scss'
import { AttributeProcessingProvider } from './AttributeProcessingContext'
import LeftPanel from './components/LeftPanel/LeftPanel'
import RightPanel from './components/RightPanel/RightPanel'

function AttributeProcessing() {
  const selectedOrganisation = useUserInfoStore(
    (state) => state.selectedOrganisation
  )
  const pageClassName = Object.keys(selectedOrganisation).length
    ? [cn.page, 'organisationSelected'].join(' ')
    : cn.page

  return (
    <AttributeProcessingProvider>
      <div className={pageClassName}>
        <LeftPanel />
        <RightPanel />
      </div>
    </AttributeProcessingProvider>
  )
}

export default AttributeProcessing
